import {FC, useEffect, useMemo, useState} from 'react'
import {useReportFilterAndPage} from '../../../hooks/useReportFilterAndPage'
import moment from 'moment-timezone'
import {
  useCancelCampaignMutation,
  useLazyGetAllCampaignListReportQuery,
  useLazyGetAllCampaignReportExportQuery,
  useLazyGetCampaignExportsQuery,
  useRescheduleCampaignMutation,
} from '../../../../services/cellcast'
import {
  useCancelCampaignMutation as useCancelSendingCampaignMutation,
  useLazySendReportToEmailQuery,
  usePauseCampaignMutation,
  useResumeCampaignMutation,
} from '../../../../services/cellcast.v2'
import {Link, useNavigate} from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import {Button, OverlayTrigger, Spinner, Tooltip, Row, Col} from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import {MessageType} from './Types'
import {capitalizeFirstLetter} from '../../../Utils/_helpers'
import {KTSVG} from '../../../../_metronic/helpers'
import InsertNewData from '../../../Components/InsertNewData'
import {toast} from 'react-toastify'
import {storeReportId, storeSchedulerId} from './reportSlices/reportAnalytics'
import {useDispatch, useSelector} from 'react-redux'
import {
  fetchAsyncUserDetails,
  getIsDefaultRegion,
} from '../accounts/Overview/OverviewSlice/UserDetailsSlice'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {useGetReportCampaignQuery} from '../../../../services/cellcast.v3'
import {formatNumber} from '../../../Utils/AllHelperFunctions'
import MatrixCard from '../../../Components/MatrixCard'
import {BulkMatrixType} from '../../../../services/cellcast.v2.types'
import {useBulkMessageMatrixReport} from './hooks/useBulkMessageMatrixReport'
import {Dropdown} from 'react-bootstrap'
import {useLoadedData} from '../../../hooks/useGetLoadedData'
import {getUserData} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'

const BulkMessages: FC = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const UserDetails: any = useSelector(getUserData)

  const {
    // SMS Configuration
    page,
    setPage,
    startDate,
    endDate,
    setDateRange,
    search,
    setSearch,
    status,
    setStatus,
    limit,
    setLimit,

    // MMS Configuration
    mmsPage,
    setMmsPage,
    startDateMms,
    endDateMms,
    setDateRangeMms,
    searchMms,
    setSearchMms,
    statusMms,
    setStatusMms,
    limitMms,
    setLimitMms,
  } = useReportFilterAndPage()

  const [fetchSms, {isLoading, data, isFetching}] = useLazyGetAllCampaignListReportQuery()
  const [fetchMms, {isLoading: isLoadingMms, data: mmsData, isFetching: isFetchingMms}] =
    useLazyGetAllCampaignListReportQuery()

  const {isLoading: reportCampaignLoading, data: reportCampaignData} = useGetReportCampaignQuery(
    {
      type: MessageType.SMS,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
      limit: 5,
      page: page,
    },
    {
      skip: isDefaultRegion,
    }
  )

  const {calculate, loadedData, setLoadedData} = useLoadedData()
  const {
    calculate: calculateMms,
    loadedData: loadedDataMms,
    setLoadedData: setLoadedDataMms,
  } = useLoadedData()

  const {matrixData, loadingState: isLoadingMatrix, portelliAccount} = useBulkMessageMatrixReport()

  useEffect(() => {
    if (startDate && endDate) {
      fetchSms({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        camp_type: MessageType.SMS.toLocaleLowerCase(),
        page: page,
        name: search,
        status: status,
        limit: limit,
      })
    }
  }, [endDate, page, startDate, limit, status])

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  useEffect(() => {
    if (startDateMms && endDateMms) {
      fetchMms({
        fromDate: moment(startDateMms).format('YYYY-MM-DD'),
        toDate: moment(endDateMms).format('YYYY-MM-DD'),
        camp_type: MessageType.MMS.toLocaleLowerCase(),
        page: mmsPage,
        name: searchMms,
        status: statusMms,
        limit: limitMms,
      })
    }
  }, [endDateMms, mmsPage, startDateMms, limitMms, statusMms])

  useEffect(() => {
    if (mmsData) {
      const loadedDataMms = calculateMms(
        mmsData && mmsData.data.current ? mmsData.data.current : 1,
        limit,
        mmsData && mmsData.data.total ? mmsData.data.total : 0
      )
      setLoadedDataMms(loadedDataMms)
    }
  }, [isLoadingMms, isFetchingMms])

  const [getCampaignExports, {isFetching: isFetchingExports}] = useLazyGetCampaignExportsQuery()
  const [sendReportAsEmail, {isLoading: isSendReportLoading}] = useLazySendReportToEmailQuery()
  const [activeSendEmailReport, setActiveSendEmailReport] = useState('')
  const [selectedBulk, setSelectedBulk] = useState<{interval?: number; scheduleAt?: number} | null>(
    null
  )

  const [isOpenConfirmation, setIsOpenConfirmation] = useState(false)
  const [cancelParam, setCancelParam] = useState<{
    id: string
    staggerMessages: boolean
    staggerId: null | string
    type: string
  } | null>(null)

  const [rescheduleParam, setRescheduleParam] = useState<{
    id: string
    staggerMessages: boolean
    staggerId: null | string
    type: string
    scheduleAt?: number
    interval?: number
  } | null>(null)

  // cancel
  const [isOpenCancelConfirmation, setIsOpenCancelConfirmation] = useState(false)
  const [cancelIdParam, setCancelIdParam] = useState('')
  const [cancelSendingMessage, {isLoading: cancelCampaignLoading}] =
    useCancelSendingCampaignMutation()

  // pause
  const [isOpenPauseConfirmation, setIsOpenPauseConfirmation] = useState(false)
  const [pauseIdParam, setPauseIdParam] = useState('')
  const [pauseSendingMessage, {isLoading: pauseCampaignLoading}] = usePauseCampaignMutation()

  // resume
  const [isOpenResumeConfirmation, setIsOpenResumeConfirmation] = useState(false)
  const [resumeIdParam, setResumeIdParam] = useState('')
  const [resumeSendingMessage, {isLoading: resumeCampaignLoading}] = useResumeCampaignMutation()

  // reschedule
  const [isOpenRescheduleConfirmation, setIsOpenRescheduleConfirmation] = useState(false)
  const [rescheduleCampaign, {isLoading: rescheduleLoading}] = useRescheduleCampaignMutation()

  // campaignType
  const [campaignType, setCampaignType] = useState('')

  const getDisplayStatus = (key: any) => {
    if (key?.cancelledAt || key?.canceledAt) {
      return 'Canceled'
    }
    if (key?.pausedAt) {
      return 'Paused'
    }
    if (key?.finalStatus !== 'In Progress') {
      return key?.finalStatus
    }

    return 'In Progress'
  }

  const getStatusColor = (key: any): string => {
    const status = getDisplayStatus(key)
    switch (status) {
      case 'In Progress':
      case 'Paused':
      case 'Scheduled':
        return 'warning'
      case 'Canceled':
      case 'Failed':
        return 'danger'
      default:
        return 'success'
    }
  }

  const cancelConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenConfirmation}
        handleClose={() => {
          setIsOpenConfirmation(false)
          setCancelParam(null)
        }}
        Message={'Are you sure, you want to cancel the campaign ?'}
        confirm={() => {
          if (cancelParam) {
            handleCancelCampaign(cancelParam.id, cancelParam.staggerMessages, cancelParam.staggerId)
            setCancelParam(null)
          }
        }}
        confirmBtnTitle='Yes, cancel campaign'
      />
    ),
    [isOpenConfirmation, cancelParam]
  )

  const rescheduleConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenRescheduleConfirmation}
        handleClose={() => {
          setIsOpenRescheduleConfirmation(false)
          setRescheduleParam(null)
        }}
        Message={'Are you sure, you want to reschedule the campaign ?'}
        selectedBulk={selectedBulk}
        isReschedule={true}
        confirm={({interval, scheduleAt}: {interval: number; scheduleAt: number}) => {
          if (rescheduleParam) {
            handleRescheduleCampaign(
              rescheduleParam.id,
              rescheduleParam.staggerMessages,
              rescheduleParam.staggerId,
              scheduleAt ? moment(scheduleAt).unix() : 0,
              interval
            )
            setRescheduleParam(null)
          }
        }}
        confirmBtnTitle='Yes, reschedule campaign'
      />
    ),
    [isOpenRescheduleConfirmation, rescheduleParam]
  )

  const cancelSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenCancelConfirmation}
        handleClose={() => {
          setIsOpenCancelConfirmation(false)
          setCancelIdParam('')
        }}
        Message={'Are you sure, you want to cancel this campaign ?'}
        confirm={() => {
          if (cancelIdParam) {
            cancelSendingMessage({
              bulkId: cancelIdParam,
              type: campaignType,
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error cancel campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenCancelConfirmation(false)
                setCancelIdParam('')
                setCampaignType('')
                fetchSms({
                  fromDate: moment(startDate).format('YYYY-MM-DD'),
                  toDate: moment(endDate).format('YYYY-MM-DD'),
                  camp_type: MessageType.SMS.toLocaleLowerCase(),
                  page: page,
                })

                fetchMms({
                  fromDate: moment(startDate).format('YYYY-MM-DD'),
                  toDate: moment(endDate).format('YYYY-MM-DD'),
                  camp_type: MessageType.MMS.toLocaleLowerCase(),
                  page: page,
                })
              })
          }
        }}
        confirmBtnTitle='Yes, cancel campaign'
      />
    ),
    [isOpenCancelConfirmation, cancelIdParam, cancelSendingMessage]
  )

  const pauseSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenPauseConfirmation}
        handleClose={() => {
          setIsOpenPauseConfirmation(false)
          setPauseIdParam('')
        }}
        Message={'Are you sure, you want to pause this campaign ?'}
        confirm={() => {
          if (pauseIdParam) {
            pauseSendingMessage({
              bulkId: pauseIdParam,
              type: campaignType,
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error pause campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenPauseConfirmation(false)
                setPauseIdParam('')
                setCampaignType('')
                fetchSms({
                  fromDate: moment(startDate).format('YYYY-MM-DD'),
                  toDate: moment(endDate).format('YYYY-MM-DD'),
                  camp_type: MessageType.SMS.toLocaleLowerCase(),
                  page: page,
                })

                fetchMms({
                  fromDate: moment(startDate).format('YYYY-MM-DD'),
                  toDate: moment(endDate).format('YYYY-MM-DD'),
                  camp_type: MessageType.MMS.toLocaleLowerCase(),
                  page: page,
                })
              })
          }
        }}
        confirmBtnTitle='Yes, pause campaign'
      />
    ),
    [isOpenPauseConfirmation, pauseIdParam, pauseSendingMessage]
  )

  const resumeSendingMessageConfirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={isOpenResumeConfirmation}
        handleClose={() => {
          setIsOpenResumeConfirmation(false)
          setResumeIdParam('')
          setSelectedBulk(null)
        }}
        Message={'Do you want to resume this campaign, please select an option below'}
        selectedBulk={selectedBulk}
        withIntervalConfirmation={true}
        confirm={({interval, scheduleAt}: {interval: number; scheduleAt: string}) => {
          if (resumeIdParam) {
            resumeSendingMessage({
              bulkId: resumeIdParam,
              type: campaignType,
              interval,
              scheduleAt: scheduleAt ? moment(scheduleAt).unix() : 0,
            })
              .then((res) => {
                if ('data' in res) {
                  toast.success(res.data?.message)
                } else if ('error' in res) {
                  toast.error(res.error)
                  console.error('Error resume campaign :', res.error)
                }
              })
              .catch((err) => {
                toast.error(err.error)
              })
              .finally(() => {
                setIsOpenResumeConfirmation(false)
                setResumeIdParam('')
                setCampaignType('')
                setSelectedBulk(null)
                fetchSms({
                  fromDate: moment(startDate).format('YYYY-MM-DD'),
                  toDate: moment(endDate).format('YYYY-MM-DD'),
                  camp_type: MessageType.SMS.toLocaleLowerCase(),
                  page: page,
                })

                fetchMms({
                  fromDate: moment(startDate).format('YYYY-MM-DD'),
                  toDate: moment(endDate).format('YYYY-MM-DD'),
                  camp_type: MessageType.MMS.toLocaleLowerCase(),
                  page: page,
                })
              })
          }
        }}
        confirmBtnTitle='Yes, resume campaign'
      />
    ),
    [isOpenResumeConfirmation, resumeIdParam, resumeSendingMessage, selectedBulk]
  )

  const [cancelCampaign, {isLoading: cancelLoading}] = useCancelCampaignMutation()
  const [getApiExport, {isLoading: isLoadingDownload}] = useLazyGetAllCampaignReportExportQuery()

  const handleCancelCampaign = (
    id: string,
    staggerMessages: boolean = false,
    staggerId: null | string = null
  ) => {
    cancelCampaign({id, staggerId, staggerMessages})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          dispatch(fetchAsyncUserDetails())
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error cancel campaign:', res.error)
        }
      })
      .finally(() => {
        fetchSms({
          fromDate: moment(startDate).format('YYYY-MM-DD'),
          toDate: moment(endDate).format('YYYY-MM-DD'),
          camp_type: MessageType.SMS.toLocaleLowerCase(),
          page: page,
        })
        fetchMms({
          fromDate: moment(startDateMms).format('YYYY-MM-DD'),
          toDate: moment(endDateMms).format('YYYY-MM-DD'),
          camp_type: MessageType.MMS.toLocaleLowerCase(),
          page: mmsPage,
        })
      })
  }

  const handleRescheduleCampaign = (
    id: string,
    staggerMessages: boolean = false,
    staggerId: null | string = null,
    scheduleAt?: number,
    interval?: number
  ) => {
    rescheduleCampaign({id, staggerId, staggerMessages, scheduleAt, interval})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          dispatch(fetchAsyncUserDetails())
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error cancel campaign:', res.error)
        }
      })
      .finally(() => {
        fetchSms({
          fromDate: moment(startDate).format('YYYY-MM-DD'),
          toDate: moment(endDate).format('YYYY-MM-DD'),
          camp_type: MessageType.SMS.toLocaleLowerCase(),
          page: page,
        })
        fetchMms({
          fromDate: moment(startDateMms).format('YYYY-MM-DD'),
          toDate: moment(endDateMms).format('YYYY-MM-DD'),
          camp_type: MessageType.MMS.toLocaleLowerCase(),
          page: mmsPage,
        })
      })
  }

  const [selectedExportId, setSelectedExportId] = useState('')

  const sendReportHandler = (bulkId: string) => {
    setActiveSendEmailReport(bulkId)
    sendReportAsEmail({
      bulkId,
      campType: 'sms',
    })
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error cancel campaign :', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
      .finally(() => {
        setActiveSendEmailReport('')
      })
  }
  const doFetchSms = () => {
    if (search.length > 0) {
      fetchSms({
        fromDate: moment(startDate).format('YYYY-MM-DD'),
        toDate: moment(endDate).format('YYYY-MM-DD'),
        camp_type: MessageType.SMS.toLocaleLowerCase(),
        page: page,
        name: search,
        status: status,
        limit: limit,
      })
    }
  }

  const doFetchMms = () => {
    if (searchMms.length > 0) {
      fetchMms({
        fromDate: moment(startDateMms).format('YYYY-MM-DD'),
        toDate: moment(endDateMms).format('YYYY-MM-DD'),
        camp_type: MessageType.MMS.toLocaleLowerCase(),
        page: mmsPage,
        name: searchMms,
        status: statusMms,
        limit: limitMms,
      })
    }
  }

  const donwloadData = (campType: string) => {
    const filterStartDate =
      campType?.toLowerCase() === 'sms'
        ? moment(startDate).format('YYYY-MM-DD')
        : moment(startDateMms).format('YYYY-MM-DD')
    const filterEndDate =
      campType?.toLowerCase() === 'sms'
        ? moment(endDate).format('YYYY-MM-DD')
        : moment(endDateMms).format('YYYY-MM-DD')

    getApiExport({
      fromDate: filterStartDate,
      toDate: filterEndDate,
      camp_type: campType?.toLowerCase(),
      page: page,
      name: search,
      status: status,
      limit: limit,
    })
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  const buildMMS = () => {
    if (isDefaultRegion) {
      return (
        <div className='mt-8'>
          <div className='card p-8'>
            <div className='card-header border-0 p-0 align-items-center mb-6'>
              <div className='d-flex flex-column w-100'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>All Bulk MMS Messages</span>
                </h3>
                <div className='d-flex mt-4 bulk-messages'>
                  <div className='col-md-6'>
                    <div className='d-flex justify-content-start'>
                      {/* search */}
                      <div className='relative d-flex gap-3'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen021.svg'
                          className='svg-icon-1 position-absolute ms-6 mt-3'
                        />
                        <input
                          type='text'
                          value={searchMms ? searchMms : ''}
                          data-kt-user-table-filter='search'
                          className='form-control form-control-solid w-250px ps-14'
                          placeholder='Find Campaign'
                          onChange={(e: any) => setSearchMms(e.target.value)}
                        />
                        <div>
                          <button
                            className={`btn btn-light-primary mt-4 mt-sm-0 ms-0 me-3`}
                            onClick={() => doFetchMms()}
                          >
                            <KTSVG path='/media/svg/search-filter.svg' className='svg-icon-2' />
                            Search
                          </button>
                        </div>
                      </div>
                      {/* filter */}
                      <div className='me-0'>
                        <Dropdown>
                          <Dropdown.Toggle className='btn btn-light-primary my-2 m-sm-0 ms-sm-3 dropdown-toggle btn btn-primary'>
                            <KTSVG path='/media/svg/filter_icon.svg' className='svg-icon-2' />
                            Filter
                          </Dropdown.Toggle>

                          <Dropdown.Menu className='w-250px'>
                            <Dropdown.Item
                              onClick={() => setStatusMms('in_progress')}
                              className='menu-content  p-3 fs-8 text-uppercase'
                            >
                              In Progress
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => setStatusMms('scheduled')}
                              className='menu-content  p-3 fs-8 text-uppercase'
                            >
                              Scheduled
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => setStatusMms('completed')}
                              className='menu-content  p-3 fs-8 text-uppercase'
                            >
                              Completed
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='d-flex justify-content-end align-content-center'>
                      <div className='d-flex'>
                        <DatePicker
                          selectsRange={true}
                          dateFormat='MMM d, yyyy'
                          className=' border-0 form-control form-control-lg form-control-solid'
                          placeholderText='Pick data & time'
                          onChange={(update: any) => {
                            setDateRangeMms(update)
                          }}
                          startDate={startDateMms}
                          endDate={endDateMms}
                          disabled={isLoadingMms}
                        />
                        <span
                          className='input-group-text'
                          style={{
                            backgroundColor: '#f5f8fa',
                            borderRadius: 0,
                            borderColor: '#f5f8fa',
                          }}
                        >
                          <i className='bi bi-calendar'></i>
                        </span>
                      </div>
                      <div className='ms-4'>
                        <button
                          type='button'
                          className='btn btn-light-primary'
                          onClick={() => donwloadData('mms')}
                        >
                          {isLoadingDownload ? (
                            <Spinner size='sm' />
                          ) : (
                            <>
                              <KTSVG
                                path='/media/icons/duotune/arrows/arr078.svg'
                                className='svg-icon-2'
                              />
                              Export
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                    {/* <div className='ms-2 col-xs-2'>
                <Select
                  value={{
                    value: campType.toString().toUpperCase(),
                    label: campType.toString().toUpperCase(),
                  }}
                  options={[
                    { value: MessageType.SMS, label: MessageType.SMS.toString().toUpperCase() },
                    { value: MessageType.MMS, label: MessageType.MMS.toString().toUpperCase() },
                  ]}
                  onChange={(e: any) => {
                    setCampType(e?.value)
                    setPage(1)
                  }}
                  isDisabled={isLoading}
                />
              </div> */}
                  </div>
                </div>
              </div>
            </div>
            {isLoadingMms || isFetchingMms ? (
              <div className='row flex-center h-200'>
                <Spinner />
              </div>
            ) : (
              <div className='card-body p-0'>
                {mmsData?.data?.items?.length > 0 ? (
                  <>
                    <div className='table-responsive'>
                      <table
                        id='bulk-messages-mms-table'
                        className='table table-bordered sticky-header table-last-column table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 all-message-table'
                      >
                        <thead>
                          <tr className='fw-400 text-muted'>
                            <th className='p-0 w-3000px ps-0'>CAMPAIGN</th>
                            <th className='p-0 w-50px'>TYPE</th>
                            <th className='p-0 min-w-150px ps-3'>SENT DATE</th>
                            <th className='p-0 min-w-40px ps-2'>RECIPIENTS</th>
                            <th className='p-0 min-w-40px ps-2'>STAGGER</th>
                            <th className='p-0 min-w-40px ps-2'>UNSUB</th>
                            <th className='p-0 min-w-40px ps-3'>CLICK THROUGH</th>
                            <th className='p-0 min-w-40px ps-2'>REPLIES</th>
                            <th className='p-0 min-w-40px ps-2'>CREDIT</th>
                            <th className='p-0 min-w-40px ps-3'>STATUS</th>
                            <th className='p-0 min-w-40px w-150px ps-3'>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isFetchingMms ? (
                            <tr>
                              <td colSpan={10} className='text-center'>
                                <Spinner />
                              </td>
                            </tr>
                          ) : (
                            <>
                              {mmsData?.data?.items?.map((key: any, i: number) => (
                                <tr key={i} className='border-dashed border-2 border-bottom'>
                                  <td>
                                    <span className='text-dark fw-400 p-0 d-block mb-1 fs-6'>
                                      {key?.name}
                                    </span>
                                    <span className='text-gray-400 fw-light p-0'>
                                      Created {moment(key?.createdAt).format('l')}
                                    </span>
                                  </td>
                                  <td className='ps-0'>
                                    <div className='symbol symbol-50px me-2'>
                                      <span className='badge blue_text_badge fs-12 badge-square p-2'>
                                        MMS
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {moment(key?.scheduleAt || key?.createdAt).format(
                                        'MMMM DD, YYYY hh:mm A'
                                      )}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.staggerId && key?.totalRecipients
                                        ? `${key?.completedRecipients}/${key?.totalRecipients}`
                                        : key?.recipients}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.staggerId && key?.totalRecipients
                                        ? `${key?.completedCount} / ${
                                            key?.completedCount + key?.scheduledCount
                                          }`
                                        : '-'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.unsub}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.clickThrough}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.replies}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.creditAmount}
                                    </span>
                                  </td>

                                  <td>
                                    <span
                                      className={`badge badge-light-${getStatusColor(key)} fw-bold`}
                                    >
                                      {getDisplayStatus(key)}
                                    </span>

                                    <div className=''>
                                      {(key?.canceledAt || key?.pausedAt) &&
                                        moment(key?.canceledAt || key?.pausedAt).format(
                                          'MMMM DD, YYYY hh:mm A'
                                        )}
                                    </div>
                                  </td>
                                  <td className='text-center'>
                                    <>
                                      {/* Show Detail Button */}
                                      {
                                        <OverlayTrigger
                                          placement='top'
                                          overlay={
                                            <Tooltip id='button-tooltip'>View Detail</Tooltip>
                                          }
                                        >
                                          <Link
                                            to="#"
                                            onClick={(e) => {
                                              e.preventDefault(); // prevent immediate navigation

                                              let url =
                                                key?.finalStatus?.toLowerCase() !== "scheduled"
                                                  ? "/eofy/snapshot"
                                                  : "/scheduler/snapshot";

                                              const payload = {
                                                camp_type: MessageType.MMS.toLowerCase(),
                                                id: key?._id,
                                              };

                                              // Completed campaign
                                              if (key?.finalStatus?.toLowerCase() === "completed") {
                                                payload.id = key?._id;
                                                dispatch(storeReportId(payload));
                                              }
                                              // Scheduled
                                              else if (key?.finalStatus?.toLowerCase() === "scheduled") {
                                                payload.id = key?._id;
                                                dispatch(storeSchedulerId(payload));
                                              }
                                              // In progress (stagger)
                                              else if (
                                                key?.staggerId &&
                                                key?.finalStatus?.toLowerCase() === "in progress" &&
                                                key?.bulkId
                                              ) {
                                                payload.id = key?.bulkId;
                                                dispatch(storeReportId(payload));
                                              }
                                              // Default
                                              else {
                                                payload.id = key?.bulkId ? key?.bulkId : key?._id;
                                                dispatch(storeReportId(payload));
                                              }

                                              // ⭐ Wait for dispatch to finish, then open new tab
                                              setTimeout(() => {
                                                window.open(url, "_blank");
                                              }, 100); // small delay to ensure store updated
                                            }}
                                            className="btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                          >
                                            <KTSVG path="/media/icons/duotune/arrows/arr064.svg" className="svg-icon-2" />
                                          </Link>
                                        </OverlayTrigger>
                                      }

                                      {key?.finalStatus.toLowerCase() === 'completed' && (
                                        <OverlayTrigger
                                          placement='top'
                                          overlay={
                                            <Tooltip id='button-tooltip'>Export Report</Tooltip>
                                          }
                                        >
                                          <button
                                            disabled={isFetchingExports}
                                            onClick={() => {
                                              setSelectedExportId(key?._id)
                                              getCampaignExports({
                                                campId: key?._id,
                                                campType: MessageType.MMS.toLowerCase(),
                                              })
                                                .unwrap()
                                                .then((res: any) => {
                                                  window.open(
                                                    `${API_DOMAIN}${res?.data?.downloadurl}`,
                                                    '_self'
                                                  )
                                                })
                                            }}
                                            type='button'
                                            className='btn btn-sm btn-icon btn-light-primary ms-3'
                                          >
                                            {selectedExportId === key?._id && isFetchingExports ? (
                                              <Spinner />
                                            ) : (
                                              <>
                                                <KTSVG
                                                  path='/media/icons/duotune/arrows/arr078.svg'
                                                  className='svg-icon-2'
                                                />
                                              </>
                                            )}
                                          </button>
                                        </OverlayTrigger>
                                      )}

                                      {key?.finalStatus?.toLowerCase() !== 'completed' &&
                                        !key?.canceledAt &&
                                        !key?.pausedAt &&
                                        key?._id && (
                                          <>
                                            {/* Show pause and cancel normal campaign  when not scheduled */}
                                            {key?.finalStatus?.toLowerCase() !== 'scheduled' && (
                                              <>
                                                <OverlayTrigger
                                                  placement='top'
                                                  overlay={
                                                    <Tooltip id='button-tooltip'>Pause</Tooltip>
                                                  }
                                                >
                                                  <button
                                                    className='btn btn-disable btn-sm btn-icon btn-bg-light btn-warning ms-3'
                                                    onClick={() => {
                                                      setPauseIdParam(
                                                        key?.bulkId ? key?.bulkId : key?._id
                                                      )
                                                      setCampaignType(MessageType.MMS.toLowerCase())
                                                      setIsOpenPauseConfirmation(true)
                                                    }}
                                                  >
                                                    {pauseCampaignLoading &&
                                                    [key?._id, key?.bulkId].includes(
                                                      pauseIdParam
                                                    ) ? (
                                                      <Spinner />
                                                    ) : (
                                                      <i className='bi bi-pause fs-5'></i>
                                                    )}
                                                  </button>
                                                </OverlayTrigger>

                                                <OverlayTrigger
                                                  placement='top'
                                                  overlay={
                                                    <Tooltip id='button-tooltip'>Cancel</Tooltip>
                                                  }
                                                >
                                                  <button
                                                    className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                                    onClick={() => {
                                                      setCancelIdParam(
                                                        key?.bulkId ? key?.bulkId : key?._id
                                                      )
                                                      setCampaignType(MessageType.MMS.toLowerCase())
                                                      setIsOpenCancelConfirmation(true)
                                                    }}
                                                  >
                                                    {cancelCampaignLoading &&
                                                    [key?._id, key?.bulkId].includes(
                                                      cancelIdParam
                                                    ) ? (
                                                      <Spinner />
                                                    ) : (
                                                      <i className='bi bi-x fs-5'></i>
                                                    )}
                                                  </button>
                                                </OverlayTrigger>
                                              </>
                                            )}

                                            {/* Show only cancel campaign when it scheduled */}
                                            {key?.finalStatus?.toLowerCase() === 'scheduled' && (
                                              <>
                                                <OverlayTrigger
                                                  placement='top'
                                                  overlay={
                                                    <Tooltip id='button-tooltip'>
                                                      Re-Schedule Campaign
                                                    </Tooltip>
                                                  }
                                                >
                                                  <button
                                                    className='btn btn-disable btn-sm btn-icon btn-bg-light btn-warning ms-3'
                                                    onClick={() => {
                                                      setRescheduleParam({
                                                        id: key?.queueJobId,
                                                        staggerMessages: key?.staggerMessages,
                                                        staggerId: key?.staggerId,
                                                        type: MessageType.SMS.toLowerCase(),
                                                      })
                                                      setSelectedBulk(key)
                                                      setIsOpenRescheduleConfirmation(true)
                                                    }}
                                                    disabled={rescheduleLoading}
                                                  >
                                                    {rescheduleLoading ? (
                                                      <Spinner />
                                                    ) : (
                                                      <i className='bi bi-pencil fs-5'></i>
                                                    )}
                                                  </button>
                                                </OverlayTrigger>
                                                <OverlayTrigger
                                                  placement='top'
                                                  overlay={
                                                    <Tooltip id='button-tooltip'>
                                                      Cancel Schedule Campaign
                                                    </Tooltip>
                                                  }
                                                >
                                                  <button
                                                    className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                                    onClick={() => {
                                                      setCancelParam({
                                                        id: key?.queueJobId,
                                                        staggerMessages: key?.staggerMessages,
                                                        staggerId: key?.staggerId,
                                                        type: MessageType.MMS.toLowerCase(),
                                                      })
                                                      setIsOpenConfirmation(true)
                                                    }}
                                                    disabled={cancelLoading}
                                                  >
                                                    {cancelLoading ? (
                                                      <Spinner />
                                                    ) : (
                                                      <i className='bi bi-x fs-5'></i>
                                                    )}
                                                  </button>
                                                </OverlayTrigger>
                                              </>
                                            )}
                                          </>
                                        )}

                                      {key?.pausedAt && (
                                        <>
                                          <OverlayTrigger
                                            placement='top'
                                            overlay={<Tooltip id='button-tooltip'>Resume</Tooltip>}
                                          >
                                            <button
                                              className='btn btn-disable btn-sm btn-icon btn-bg-light btn-info ms-3'
                                              onClick={() => {
                                                setResumeIdParam(
                                                  key?.bulkId ? key?.bulkId : key?._id
                                                )
                                                setSelectedBulk(key)
                                                setCampaignType(MessageType.MMS.toLowerCase())
                                                setIsOpenResumeConfirmation(true)
                                              }}
                                            >
                                              {resumeCampaignLoading &&
                                              [key?._id, key?.bulkId].includes(resumeIdParam) ? (
                                                <Spinner />
                                              ) : (
                                                <i className='bi bi-arrow-clockwise fs-5'></i>
                                              )}
                                            </button>
                                          </OverlayTrigger>

                                          <OverlayTrigger
                                            placement='top'
                                            overlay={<Tooltip id='button-tooltip'>Cancel</Tooltip>}
                                          >
                                            <button
                                              className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                              onClick={() => {
                                                setCancelIdParam(
                                                  key?.bulkId ? key?.bulkId : key?._id
                                                )
                                                setCampaignType(MessageType.MMS.toLowerCase())
                                                setIsOpenCancelConfirmation(true)
                                              }}
                                            >
                                              {cancelCampaignLoading &&
                                              [key?._id, key?.bulkId].includes(cancelIdParam) ? (
                                                <Spinner />
                                              ) : (
                                                <i className='bi bi-x fs-5'></i>
                                              )}
                                            </button>
                                          </OverlayTrigger>
                                        </>
                                      )}
                                    </>
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className='abcd'>
                      <select
                        onChange={(e: any) => {
                          setLimitMms(e.target.value)
                        }}
                      >
                        <option value={10} selected={limitMms === 10}>
                          10
                        </option>
                        <option value={20} selected={limitMms === 20}>
                          20
                        </option>
                        <option value={50} selected={limitMms === 50}>
                          50
                        </option>
                      </select>
                      {isFetching
                        ? '. . . . .'
                        : `Show ${loadedDataMms.startLoad} - ${loadedDataMms.endLoad} of ${
                            mmsData.data.total ? mmsData.data.total : 0
                          } Campaigns`}
                      <ReactPaginate
                        previousLabel='<'
                        nextLabel='>'
                        pageCount={mmsData?.data?.totalPages}
                        onPageChange={(e: any) => {
                          setMmsPage(e.selected + 1)
                        }}
                        containerClassName={'pagination'}
                        previousLinkClassName={'pagination__link'}
                        nextLinkClassName={'pagination__link'}
                        disabledClassName={'pagination__link--disabled'}
                        activeClassName={'pagination__link--active'}
                      />
                    </div>
                  </>
                ) : (
                  <InsertNewData
                    message={{
                      title: 'No recent bulk messages (yet!)',
                      subtitle: `If you do not see your reports please ensure you have selected the correct date range above.`,
                    }}
                    buttonName={{
                      name: 'Send bulk message',
                      link: '/new-message',
                      popup: false,
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      )
    }
  }

  const buildSMS = () => {
    if (isDefaultRegion) {
      return (
        <div className='mt-8'>
          <div className='card p-8'>
            <div className='card-header border-0 p-0 align-items-center mb-6'>
              <div className='d-flex flex-column w-100'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>All Bulk SMS Messages</span>
                </h3>
                <div className='d-flex mt-4 bulk-messages'>
                  <div className='col-md-6'>
                    <div className='d-flex justify-content-start'>
                      {/* search */}
                      <div className='relative d-flex gap-3'>
                        <KTSVG
                          path='/media/icons/duotune/general/gen021.svg'
                          className='svg-icon-1 position-absolute ms-6 mt-3'
                        />
                        <input
                          type='text'
                          value={search ? search : ''}
                          data-kt-user-table-filter='search'
                          className='form-control form-control-solid w-250px ps-14'
                          placeholder='Find Campaign'
                          onChange={(e: any) => setSearch(e.target.value)}
                        />
                        <div>
                          <button
                            className={`btn btn-light-primary mt-4 mt-sm-0 ms-0 me-3`}
                            onClick={() => doFetchSms()}
                          >
                            <KTSVG path='/media/svg/search-filter.svg' className='svg-icon-2' />
                            Search
                          </button>
                        </div>
                      </div>
                      {/* filter */}
                      <div className='me-0'>
                        <Dropdown>
                          <Dropdown.Toggle className='btn btn-light-primary my-2 m-sm-0 ms-sm-3 dropdown-toggle btn btn-primary'>
                            <KTSVG path='/media/svg/filter_icon.svg' className='svg-icon-2' />
                            Filter
                          </Dropdown.Toggle>

                          <Dropdown.Menu className='w-250px'>
                            <Dropdown.Item
                              onClick={() => setStatus('in_progress')}
                              className='menu-content  p-3 fs-8 text-uppercase'
                            >
                              In Progress
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => setStatus('scheduled')}
                              className='menu-content  p-3 fs-8 text-uppercase'
                            >
                              Scheduled
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => setStatus('completed')}
                              className='menu-content  p-3 fs-8 text-uppercase'
                            >
                              Completed
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='d-flex justify-content-end align-content-center'>
                      <div className='d-flex'>
                        <DatePicker
                          selectsRange={true}
                          dateFormat='MMM d, yyyy'
                          className=' border-0 form-control form-control-lg form-control-solid'
                          placeholderText='Pick data & time'
                          onChange={(update: any) => {
                            setDateRange(update)
                          }}
                          startDate={startDate}
                          endDate={endDate}
                          disabled={isLoading}
                        />
                        <span
                          className='input-group-text'
                          style={{
                            backgroundColor: '#f5f8fa',
                            borderRadius: 0,
                            borderColor: '#f5f8fa',
                          }}
                        >
                          <i className='bi bi-calendar'></i>
                        </span>
                      </div>
                      <div className='ms-4'>
                        <button
                          type='button'
                          className='btn btn-light-primary'
                          onClick={() => donwloadData('sms')}
                        >
                          {isLoadingDownload ? (
                            <Spinner size='sm' />
                          ) : (
                            <>
                              <KTSVG
                                path='/media/icons/duotune/arrows/arr078.svg'
                                className='svg-icon-2'
                              />
                              Export
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                  {/* <div className='ms-2 col-xs-2'>
                <Select
                  value={{
                    value: campType.toString().toUpperCase(),
                    label: campType.toString().toUpperCase(),
                  }}
                  options={[
                    { value: MessageType.SMS, label: MessageType.SMS.toString().toUpperCase() },
                    { value: MessageType.MMS, label: MessageType.MMS.toString().toUpperCase() },
                  ]}
                  onChange={(e: any) => {
                    setCampType(e?.value)
                    setPage(1)
                  }}
                  isDisabled={isLoading}
                />
              </div> */}
                </div>
              </div>
            </div>

            {isLoading || isFetching ? (
              <div className='row flex-center h-200'>
                <Spinner />
              </div>
            ) : (
              <div className='card-body p-0'>
                {data?.data?.items?.length > 0 ? (
                  <>
                    <div className='table-responsive  max-h-750'>
                      <table
                        id='bulk-messages-mms-table'
                        className='table table-bordered sticky-header table-last-column table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'
                      >
                        <thead>
                          <tr className='fw-400 text-muted'>
                            <th className='p-0 w-3000px ps-0'>CAMPAIGN</th>
                            <th className='p-0 w-50px'>TYPE</th>
                            <th className='p-0 min-w-150px ps-3'>SENT DATE</th>
                            <th className='p-0 min-w-40px ps-2'>RECIPIENTS</th>
                            <th className='p-0 min-w-40px ps-2'>STAGGER</th>
                            <th className='p-0 min-w-40px ps-2'>UNSUB</th>
                            <th className='p-0 min-w-40px ps-3'>CLICK THROUGH</th>
                            <th className='p-0 min-w-40px ps-2'>REPLIES</th>
                            <th className='p-0 min-w-40px ps-2'>CREDIT</th>
                            <th className='p-0 min-w-40px ps-3'>STATUS</th>
                            <th className='p-0 min-w-150px ps-3'>ACTION</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isFetching ? (
                            <tr>
                              <td colSpan={10} className='text-center'>
                                <Spinner />
                              </td>
                            </tr>
                          ) : (
                            <>
                              {data?.data?.items?.map((key: any, i: number) => (
                                <tr key={i} className='border-dashed border-2 border-bottom'>
                                  <td>
                                    <span className='text-dark fw-400 p-0 d-block mb-1 fs-6'>
                                      {key?.name}
                                    </span>
                                    <span className='text-gray-400 fw-light p-0'>
                                      Created {moment(key?.createdAt).format('l')}
                                    </span>
                                  </td>
                                  <td className='ps-0'>
                                    <div className='symbol symbol-50px me-2'>
                                      <span className='badge green_text_badge fs-12 badge-square p-2'>
                                        SMS
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {moment(key?.scheduleAt || key?.createdAt).format(
                                        'MMMM DD, YYYY hh:mm A'
                                      )}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.staggerId && key?.totalRecipients
                                        ? `${key?.completedRecipients}/${key?.totalRecipients}`
                                        : key?.recipients}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.staggerId && key?.totalRecipients
                                        ? `${key?.completedCount} / ${
                                            key?.completedCount + key?.scheduledCount
                                          }`
                                        : '-'}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.unsub}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.clickThrough}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.replies ?? 0}
                                    </span>
                                  </td>
                                  <td>
                                    <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                      {key?.creditAmount}
                                    </span>
                                  </td>
                                  <td>
                                    <span
                                      className={`badge badge-light-${getStatusColor(key)} fw-bold`}
                                    >
                                      {getDisplayStatus(key)}
                                    </span>
                                    <div>
                                      {(key?.canceledAt || key?.pausedAt) &&
                                        moment(key?.canceledAt || key?.pausedAt).format(
                                          'MMMM DD, YYYY hh:mm A'
                                        )}
                                    </div>

                                    {data?.data?.isArchive && (
                                      <span className={`ms-2 badge badge-light-warning fw-bold`}>
                                        Archived
                                      </span>
                                    )}
                                  </td>
                                  <td className='text-center'>
                                    {data?.data?.isArchive ? (
                                      <>
                                        <OverlayTrigger
                                          placement='top'
                                          overlay={
                                            <Tooltip id='button-tooltip'>
                                              Send report as email
                                            </Tooltip>
                                          }
                                        >
                                          <button
                                            className='btn btn-sm btn-bg-light btn-info'
                                            onClick={() => sendReportHandler(key?._id)}
                                          >
                                            {isSendReportLoading &&
                                            key?._id === activeSendEmailReport ? (
                                              <Spinner size='sm' />
                                            ) : (
                                              'Send Email'
                                            )}
                                          </button>
                                        </OverlayTrigger>
                                      </>
                                    ) : (
                                      <>
                                        {/* Show Detail Button */}
                                        {
                                          <OverlayTrigger
                                            placement='top'
                                            overlay={
                                              <Tooltip id='button-tooltip'>View Detail</Tooltip>
                                            }
                                          >
                                            <Link
                                              to={`${
                                                key?.finalStatus?.toLowerCase() !== 'scheduled'
                                                  ? '/eofy/snapshot'
                                                  : '/scheduler/snapshot'
                                              }`}
                                              target='_blank'
                                              onClick={() => {
                                                // Completed campaign
                                                if (
                                                  key?.finalStatus?.toLowerCase() === 'completed'
                                                ) {
                                                  dispatch(
                                                    storeReportId({
                                                      id: key?._id,
                                                      camp_type: MessageType.SMS.toLowerCase(),
                                                    })
                                                  )

                                                  return
                                                }

                                                if (
                                                  key?.finalStatus?.toLowerCase() === 'scheduled'
                                                ) {
                                                  dispatch(
                                                    storeSchedulerId({
                                                      id: key?._id,
                                                      camp_type: MessageType.SMS.toLowerCase(),
                                                    })
                                                  )
                                                  return
                                                }

                                                // In progress stagger campaign
                                                if (
                                                  key?.staggerId &&
                                                  key?.finalStatus?.toLowerCase() ===
                                                    'in progress' &&
                                                  key?.bulkId
                                                ) {
                                                  dispatch(
                                                    storeReportId({
                                                      id: key?.bulkId,
                                                      camp_type: MessageType.SMS.toLowerCase(),
                                                    })
                                                  )
                                                  return
                                                }

                                                // Default state for running campaign
                                                dispatch(
                                                  storeReportId({
                                                    id: key?.bulkId ? key?.bulkId : key?._id,
                                                    camp_type: MessageType.SMS.toLowerCase(),
                                                  })
                                                )
                                              }}
                                              className='btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                            >
                                              <KTSVG
                                                path='/media/icons/duotune/arrows/arr064.svg'
                                                className='svg-icon-2'
                                              />
                                            </Link>
                                          </OverlayTrigger>
                                        }

                                        {key?.finalStatus.toLowerCase() === 'completed' && (
                                          <OverlayTrigger
                                            placement='bottom'
                                            overlay={
                                              <Tooltip id='button-tooltip'>Export Report</Tooltip>
                                            }
                                          >
                                            <button
                                              disabled={isFetchingExports}
                                              onClick={() => {
                                                setSelectedExportId(key?._id)
                                                getCampaignExports({
                                                  campId: key?._id,
                                                  campType: MessageType.SMS.toLowerCase(),
                                                })
                                                  .unwrap()
                                                  .then((res: any) => {
                                                    window.open(
                                                      `${API_DOMAIN}${res?.data?.downloadurl}`,
                                                      '_self'
                                                    )
                                                  })
                                              }}
                                              type='button'
                                              className='btn btn-sm btn-icon btn-light-primary ms-3'
                                            >
                                              {selectedExportId === key?._id &&
                                              isFetchingExports ? (
                                                <Spinner />
                                              ) : (
                                                <>
                                                  <KTSVG
                                                    path='/media/icons/duotune/arrows/arr078.svg'
                                                    className='svg-icon-2'
                                                  />
                                                </>
                                              )}
                                            </button>
                                          </OverlayTrigger>
                                        )}

                                        {key?.finalStatus?.toLowerCase() !== 'completed' &&
                                          !key?.canceledAt &&
                                          !key?.pausedAt &&
                                          key?._id && (
                                            <>
                                              {/* Show pause and cancel normal campaign  when not scheduled */}
                                              {key?.finalStatus?.toLowerCase() !== 'scheduled' && (
                                                <>
                                                  <OverlayTrigger
                                                    placement='top'
                                                    overlay={
                                                      <Tooltip id='button-tooltip'>Pause</Tooltip>
                                                    }
                                                  >
                                                    <button
                                                      className='btn btn-disable btn-sm btn-icon btn-bg-light btn-warning ms-3'
                                                      onClick={() => {
                                                        setPauseIdParam(
                                                          key?.bulkId ? key?.bulkId : key?._id
                                                        )
                                                        setCampaignType(
                                                          MessageType.SMS.toLowerCase()
                                                        )
                                                        setIsOpenPauseConfirmation(true)
                                                      }}
                                                    >
                                                      {pauseCampaignLoading &&
                                                      [key?._id, key?.bulkId].includes(
                                                        pauseIdParam
                                                      ) ? (
                                                        <Spinner />
                                                      ) : (
                                                        <i className='bi bi-pause fs-5'></i>
                                                      )}
                                                    </button>
                                                  </OverlayTrigger>

                                                  <OverlayTrigger
                                                    placement='top'
                                                    overlay={
                                                      <Tooltip id='button-tooltip'>Cancel</Tooltip>
                                                    }
                                                  >
                                                    <button
                                                      className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                                      onClick={() => {
                                                        setCancelIdParam(
                                                          key?.bulkId ? key?.bulkId : key?._id
                                                        )
                                                        setCampaignType(
                                                          MessageType.SMS.toLowerCase()
                                                        )
                                                        setIsOpenCancelConfirmation(true)
                                                      }}
                                                    >
                                                      {cancelCampaignLoading &&
                                                      [key?._id, key?.bulkId].includes(
                                                        cancelIdParam
                                                      ) ? (
                                                        <Spinner />
                                                      ) : (
                                                        <i className='bi bi-x fs-5'></i>
                                                      )}
                                                    </button>
                                                  </OverlayTrigger>
                                                </>
                                              )}

                                              {/* Show only cancel campaign when it scheduled */}
                                              {key?.finalStatus?.toLowerCase() === 'scheduled' && (
                                                <>
                                                  <OverlayTrigger
                                                    placement='top'
                                                    overlay={
                                                      <Tooltip id='button-tooltip'>
                                                        Re-Schedule Campaign
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <button
                                                      className='btn btn-disable btn-sm btn-icon btn-bg-light btn-warning ms-3'
                                                      onClick={() => {
                                                        setRescheduleParam({
                                                          id: key?.queueJobId,
                                                          staggerMessages: key?.staggerMessages,
                                                          staggerId: key?.staggerId,
                                                          type: MessageType.SMS.toLowerCase(),
                                                        })
                                                        setSelectedBulk(key)
                                                        setIsOpenRescheduleConfirmation(true)
                                                      }}
                                                      disabled={rescheduleLoading}
                                                    >
                                                      {rescheduleLoading ? (
                                                        <Spinner />
                                                      ) : (
                                                        <i className='bi bi-pencil fs-5'></i>
                                                      )}
                                                    </button>
                                                  </OverlayTrigger>

                                                  <OverlayTrigger
                                                    placement='top'
                                                    overlay={
                                                      <Tooltip id='button-tooltip'>
                                                        Cancel Schedule Campaign
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <button
                                                      className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                                      onClick={() => {
                                                        setCancelParam({
                                                          id: key?.queueJobId,
                                                          staggerMessages: key?.staggerMessages,
                                                          staggerId: key?.staggerId,
                                                          type: MessageType.SMS.toLowerCase(),
                                                        })
                                                        setIsOpenConfirmation(true)
                                                      }}
                                                      disabled={cancelLoading}
                                                    >
                                                      {cancelLoading ? (
                                                        <Spinner />
                                                      ) : (
                                                        <i className='bi bi-x fs-5'></i>
                                                      )}
                                                    </button>
                                                  </OverlayTrigger>
                                                </>
                                              )}
                                            </>
                                          )}

                                        {key?.pausedAt && (
                                          <>
                                            <OverlayTrigger
                                              placement='top'
                                              overlay={
                                                <Tooltip id='button-tooltip'>Resume</Tooltip>
                                              }
                                            >
                                              <button
                                                className='btn btn-disable btn-sm btn-icon btn-bg-light btn-info ms-3'
                                                onClick={() => {
                                                  setResumeIdParam(
                                                    key?.bulkId ? key?.bulkId : key?._id
                                                  )
                                                  setSelectedBulk(key)
                                                  setCampaignType(MessageType.SMS.toLowerCase())
                                                  setIsOpenResumeConfirmation(true)
                                                }}
                                              >
                                                {resumeCampaignLoading &&
                                                [key?._id, key?.bulkId].includes(resumeIdParam) ? (
                                                  <Spinner />
                                                ) : (
                                                  <i className='bi bi-arrow-clockwise fs-5'></i>
                                                )}
                                              </button>
                                            </OverlayTrigger>

                                            <OverlayTrigger
                                              placement='top'
                                              overlay={
                                                <Tooltip id='button-tooltip'>Cancel</Tooltip>
                                              }
                                            >
                                              <button
                                                className='btn btn-disable btn-sm btn-icon btn-bg-light btn-danger ms-3'
                                                onClick={() => {
                                                  setCancelIdParam(
                                                    key?.bulkId ? key?.bulkId : key?._id
                                                  )
                                                  setCampaignType(MessageType.SMS.toLowerCase())
                                                  setIsOpenCancelConfirmation(true)
                                                }}
                                              >
                                                {cancelCampaignLoading &&
                                                [key?._id, key?.bulkId].includes(cancelIdParam) ? (
                                                  <Spinner />
                                                ) : (
                                                  <i className='bi bi-x fs-5'></i>
                                                )}
                                              </button>
                                            </OverlayTrigger>
                                          </>
                                        )}
                                      </>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className='abcd'>
                      <select
                        onChange={(e: any) => {
                          setLimit(e.target.value)
                        }}
                      >
                        <option value={10} selected={limit === 10}>
                          10
                        </option>
                        <option value={20} selected={limit === 20}>
                          20
                        </option>
                        <option value={50} selected={limit === 50}>
                          50
                        </option>
                      </select>
                      {isFetching
                        ? '. . . . .'
                        : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${
                            data.data.total ? data.data.total : 0
                          } Campaigns`}
                      <ReactPaginate
                        previousLabel='<'
                        nextLabel='>'
                        pageCount={data?.data?.totalPages}
                        onPageChange={(e: any) => {
                          setPage(e.selected + 1)
                        }}
                        containerClassName={'pagination'}
                        previousLinkClassName={'pagination__link'}
                        nextLinkClassName={'pagination__link'}
                        disabledClassName={'pagination__link--disabled'}
                        activeClassName={'pagination__link--active'}
                      />
                    </div>
                  </>
                ) : (
                  <InsertNewData
                    message={{
                      title: 'No recent bulk messages (yet!)',
                      subtitle: `If you do not see your reports please ensure you have selected the correct date range above.`,
                    }}
                    buttonName={{
                      name: 'Send bulk message',
                      link: '/new-message',
                      popup: false,
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      )
    }

    return (
      <div className='mt-8'>
        <div className='card p-8'>
          <div className='card-header border-0 p-0 align-items-center mb-10'>
            <div className='d-flex flex-column w-100'>
              <h3 className='card-title align-items-start  flex-column'>
                <span className='card-label fw-bolder fs-2 mb-1'>All Bulk Messages</span>
                <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
              </h3>
              <div className='d-flex justify-content-end'>
                <div className='col-md-2'>
                  <div className='d-flex'>
                    <DatePicker
                      selectsRange={true}
                      dateFormat='MMM d, yyyy'
                      className=' border-0 form-control form-control-lg form-control-solid'
                      placeholderText='Pick data & time'
                      onChange={(update: any) => {
                        setDateRange(update)
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      disabled={isLoading}
                    />
                    <span
                      className='input-group-text'
                      style={{
                        backgroundColor: '#f5f8fa',
                        borderRadius: 0,
                        borderColor: '#f5f8fa',
                      }}
                    >
                      <i className='bi bi-calendar'></i>
                    </span>
                  </div>
                </div>
                {/* <div className='ms-2 col-xs-2'>
              <Select
                value={{
                  value: campType.toString().toUpperCase(),
                  label: campType.toString().toUpperCase(),
                }}
                options={[
                  { value: MessageType.SMS, label: MessageType.SMS.toString().toUpperCase() },
                  { value: MessageType.MMS, label: MessageType.MMS.toString().toUpperCase() },
                ]}
                onChange={(e: any) => {
                  setCampType(e?.value)
                  setPage(1)
                }}
                isDisabled={isLoading}
              />
            </div> */}
              </div>
            </div>
          </div>

          {reportCampaignLoading ? (
            <div className='row flex-center h-200'>
              <Spinner />
            </div>
          ) : (
            <div className='card-body p-0 pt-5'>
              {reportCampaignData?.data?.items?.length > 0 ? (
                <>
                  <div className='table-responsive'>
                    <table className='table table-container align-middle gs-0 gy-5 all-message-table'>
                      <thead>
                        <tr className='fw-400 text-muted '>
                          <th className='p-0 w-40px ps-0'>CAMPAIGN</th>
                          <th className='p-0 w-210px'></th>
                          <th className='p-0 min-w-150px ps-3'>SENT DATE</th>
                          <th className='p-0 min-w-40px ps-2'>RECIPIENTS</th>
                          <th className='p-0 min-w-40px ps-2'>STAGGER</th>
                          <th className='p-0 min-w-40px ps-2'>UNSUB</th>
                          <th className='p-0 min-w-40px ps-3'>CLICK THROUGH</th>
                          <th className='p-0 min-w-40px ps-2'>REPLIES</th>
                          <th className='p-0 min-w-40px ps-2'>CREDIT</th>
                          <th className='p-0 min-w-40px ps-3'>STATUS</th>
                          <th className='p-0 min-w-40px ps-3'>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isFetching ? (
                          <tr>
                            <td colSpan={10} className='text-center'>
                              <Spinner />
                            </td>
                          </tr>
                        ) : (
                          <>
                            {reportCampaignData?.data?.items?.map((key: any, i: number) => (
                              <tr key={i} className='border-dashed border-2 border-bottom'>
                                <th className='ps-0'>
                                  <div className='symbol symbol-50px me-2'>
                                    <span className='symbol-label'>
                                      <i className='badge green_text_badge fs-7 badge-square p-4 w-50px h-50px'>
                                        {key?.message_type}
                                      </i>
                                    </span>
                                  </div>
                                </th>
                                <td className=''>
                                  <span className='text-dark fw-400 p-0 d-block mb-1 fs-6'>
                                    {key?.name}
                                  </span>
                                  <span className='text-gray-400 fw-light p-0'>
                                    Created {moment(key?.created_at).format('l')}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                    {key?.created_at
                                      ? moment(key?.created_at).format('MMMM DD, YYYY hh:mm A')
                                      : moment(key?.schedule_at).format('MMMM DD, YYYY hh:mm A')}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                    {key?.total_recipient}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                    {key?.staggerId && key?.total_recipient
                                      ? `${key?.completedCount} / ${
                                          key?.completedCount + key?.scheduledCount
                                        }`
                                      : '-'}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                    {key?.unsubscribe_count}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                    {key?.tracking_link_click_count}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                    {key?.reply_count}
                                  </span>
                                </td>
                                <td>
                                  <span className='text-dark fw-400  d-block mb-1 fs-6'>
                                    {key?.credit_amount}
                                  </span>
                                </td>

                                <td>
                                  <span
                                    className={`badge badge-light-${
                                      key?.status.toLowerCase() === 'completed'
                                        ? 'success'
                                        : 'warning'
                                    } fw-bold`}
                                  >
                                    {key?.status}
                                  </span>
                                </td>
                                <td className='text-center'>
                                  {key?.status === 'cancel' && (
                                    <span className={`badge badge-light-danger ms-3 fw-bold`}>
                                      {capitalizeFirstLetter(key?.status)}
                                    </span>
                                  )}
                                  {key?.status !== 'cancel' && (
                                    <OverlayTrigger
                                      placement='bottom'
                                      overlay={<Tooltip id='button-tooltip'>View Detail</Tooltip>}
                                    >
                                      <Link
                                        to='/eofy/snapshot'
                                        target='_blank'
                                        onClick={() => {
                                          if (key?.status?.toLowerCase() === 'completed') {
                                            dispatch(
                                              storeReportId({
                                                id: key?.id,
                                                camp_type: key.message_type?.toLowerCase(),
                                                data: key,
                                              })
                                            )
                                          }
                                        }}
                                        className='btn btn-disable btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                      >
                                        <KTSVG
                                          path='/media/icons/duotune/arrows/arr064.svg'
                                          className='svg-icon-2'
                                        />
                                      </Link>
                                    </OverlayTrigger>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className='abcd'>
                    <span>
                      Total Data :{' '}
                      {reportCampaignData?.data?.total ? reportCampaignData?.data?.total : 0}
                    </span>
                    <ReactPaginate
                      previousLabel='<'
                      nextLabel='>'
                      pageCount={reportCampaignData?.data?.totalPages}
                      onPageChange={(e: any) => setPage(e.selected + 1)}
                      containerClassName={'pagination'}
                      previousLinkClassName={'pagination__link'}
                      nextLinkClassName={'pagination__link'}
                      disabledClassName={'pagination__link--disabled'}
                      activeClassName={'pagination__link--active'}
                    />
                  </div>
                </>
              ) : (
                <InsertNewData
                  message={{
                    title: 'No recent bulk messages (yet!)',
                    subtitle: `If you do not see your reports please ensure you have selected the correct date range above.`,
                  }}
                  buttonName={{
                    name: 'Send bulk message',
                    link: '/new-message',
                    popup: false,
                  }}
                />
              )}
            </div>
          )}
        </div>
      </div>
    )
  }

  const buildMatrixBulkMessage = () => {
    // 65dc62e384ba9801ac5bf76a = Adrian Portelli
    const userId = UserDetails?.user?._id
    if (isDefaultRegion && userId !== portelliAccount) {
      return (
        <div className='mt-4'>
          <Row>
            {Object.values(BulkMatrixType).map((type) => (
              <Col key={type} xs={12} sm={6} md={3}>
                {isLoadingMatrix[type] ? (
                  <div className='text-center p-4'>Loading...</div>
                ) : (
                  <MatrixCard
                    value={matrixData[type]?.value || 0}
                    type={type}
                    growthRate={matrixData[type]?.growthRate || 0}
                    tooltipText={matrixData[type]?.tooltipText}
                  />
                )}
              </Col>
            ))}
          </Row>
        </div>
      )
    }
  }

  return (
    <div className='row'>
      {rescheduleConfirmation}
      {cancelConfirmation}
      {cancelSendingMessageConfirmation}
      {pauseSendingMessageConfirmation}
      {resumeSendingMessageConfirmation}
      {buildMatrixBulkMessage()}
      {buildSMS()}
      {buildMMS()}
    </div>
  )
}

export default BulkMessages
